import React, { useEffect, useState } from "react";
import { Table, Tag, Button, message, Badge } from "antd";
import axios from "axios";
import { useAdminControl } from "../store/Store";
import axiosInstance from "../apis/axiosInstance";

import { BASE_URL } from "../apis/constant";

const ProductTable = () => {
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataSource, setDataSource] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const { openDrawer, setSelectedProduct, renderCount } = useAdminControl();

  useEffect(() => {
    const handleResize = () => setScreenHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch products from API
  const fetchProducts = async (page, pageSize) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post('/api/get_all_product_for_table/', {
        page: page,
        page_size: pageSize
      });
      const result = response.data;
      setDataSource(result.data);
      setTotal(result.total);
    } catch (error) {
      console.error(error);
      message.error("Failed to fetch products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts(currentPage, pageSize);
  }, [currentPage, pageSize, renderCount]);

  const handleEdit = (productId) => {
    setSelectedProduct(productId);
    openDrawer('productEdit');
  };

  const columns = [
    {
      title: "Product",
      key: "product",
      width: 200,
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img
            src={`${BASE_URL}/${record.image}`}
            alt={record.productName}
            style={{ width: 50, height: 50, borderRadius: 6, objectFit: "cover" }}
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontWeight: 600 }}>{record.productName}</span>
            <span style={{ fontSize: 12, color: "#888" }}>{record.category}</span>
          </div>
        </div>
      ),
    },
    {
      title: "Ranking",
      dataIndex: "ranking",
      key: "ranking",
      align: "center",
      width: 60,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 110,
      render: (statusObj) => (
        <Tag color={statusObj.color} variant="outlined" size='large' style={{ minWidth: 90, textAlign:'center'}} >
          {statusObj.status}
        </Tag>


        // <Badge color={statusObj.color} text={statusObj.status}  style={{ minWidth: 90, textAlign: "center" }}/>
      ),
    },
    {
      title: "Price",
      key: "price",
      align: "center",
      width: 60,
      render: (_, record) =>
        record.offerPrice !== null && record.offerPrice !== undefined ? (
          <div>
            <div>{record.offerPrice} BDT</div>
            <div style={{ textDecoration: "line-through", fontSize: 12, color: "#999" }}>
              {record.price} BDT
            </div>
          </div>
        ) : (
          <div>{record.price} BDT</div>
        ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      width: 60,
      render: (_, record) => (
        <Button size="small" color="default" variant="dashed" onClick={() => handleEdit(record.key)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      rowKey="key"
      size="medium"
      scroll={{ y: screenHeight - 290 }}
      loading={loading}
      pagination={{
        current: currentPage,
        pageSize: pageSize,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: ['10', '25', '50', '100'],
        onChange: (page, size) => {
          setCurrentPage(page);
          setPageSize(size);
        },
      }}
    />
  );
};

export default ProductTable;
